const reverse = p => new Promise((resolve, reject) => Promise.resolve(p).then(reject, resolve));

Promise.any = arr => reverse(Promise.all(arr.map(reverse)));
